import { Account } from '@/domain/usecases'

export type CompanyManagerCollaboratorsImportLoaderType = {
  // Future: Template options, validation rules, etc.
}

export async function loadCompanyManagerCollaboratorsImport(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _account: Account.Model
): Promise<CompanyManagerCollaboratorsImportLoaderType> {
  // Future implementation
  return {}
}
